(function () {
  var cfg = window.solveySale;
  if (!cfg) return;

  function setStyles(el, bg, color) {
    if (bg) el.style.background = bg;
    if (color) el.style.color = color;
  }

  function injectSitewideBar() {
    if (!cfg.bar || !cfg.bar.enabled) return;
    if (document.querySelector('.solvey-sale-bar')) return;
    document.body.classList.add('solvey-has-sale-bar');
    var bar = document.createElement('div');
    bar.className = 'solvey-sale-bar';
    bar.setAttribute('role', 'status');
    setStyles(bar, cfg.bar.bg, cfg.bar.color);

    var inner = document.createElement('div');
    inner.className = 'solvey-sale-bar__inner';

    if (cfg.bar.text) {
      var primary = document.createElement('span');
      primary.className = 'solvey-sale-bar__primary';
      primary.innerHTML = cfg.bar.text;
      inner.appendChild(primary);
    }

    if (cfg.bar.secondary) {
      var divider = document.createElement('span');
      divider.className = 'solvey-sale-bar__divider';
      divider.setAttribute('aria-hidden', 'true');
      divider.textContent = '|';
      inner.appendChild(divider);

      var secondary = document.createElement('span');
      secondary.className = 'solvey-sale-bar__secondary';
      secondary.innerHTML = cfg.bar.secondary;
      inner.appendChild(secondary);
    }

    if (cfg.bar.ctaText) {
      var cta = document.createElement('a');
      cta.className = 'solvey-sale-bar__cta';
      cta.href = cfg.bar.ctaLink || '/collections/all-products';
      cta.innerHTML = cfg.bar.ctaText + ' <span aria-hidden="true">&rarr;</span>';
      inner.appendChild(cta);
    }

    bar.appendChild(inner);
    document.body.insertBefore(bar, document.body.firstChild);
  }

  function injectPdpBanner() {
    if (!cfg.pdpBanner || !cfg.pdpBanner.enabled || !cfg.isPDP) return;
    if (document.querySelector('.solvey-sale-pdp-banner')) return;
    var banner = document.createElement('div');
    banner.className = 'solvey-sale-pdp-banner';
    setStyles(banner, cfg.pdpBanner.bg, cfg.pdpBanner.color);

    // Build rich structure: left disc + main text + right sparkle pill
    var inner = document.createElement('div');
    inner.className = 'solvey-sale-pdp-banner__inner';

    var discPct = cfg.pdpBanner.discPct || '20%';
    var discLabel = cfg.pdpBanner.discLabel || 'EXTRA OFF';
    var disc = document.createElement('div');
    disc.className = 'solvey-sale-pdp-banner__disc';
    disc.innerHTML = '<span class="solvey-sale-pdp-banner__disc-pct">' + discPct + '</span><span class="solvey-sale-pdp-banner__disc-label">' + discLabel + '</span>';
    inner.appendChild(disc);

    var mainTxt = document.createElement('div');
    mainTxt.className = 'solvey-sale-pdp-banner__text';
    var primaryHtml = cfg.pdpBanner.text || '';
    var subtext = cfg.pdpBanner.subtext || '';
    mainTxt.innerHTML = primaryHtml + (subtext ? '<div class="sub">' + subtext + '</div>' : '');
    inner.appendChild(mainTxt);

    var limitedText = cfg.pdpBanner.limitedText || 'LIMITED TIME ONLY';
    var rightPill = document.createElement('div');
    rightPill.className = 'solvey-sale-pdp-banner__limited';
    rightPill.innerHTML = '<span class="solvey-sale-pdp-banner__limited-text">' + limitedText + '</span><span class="solvey-sale-pdp-banner__limited-sparkle" aria-hidden="true">✦</span>';
    inner.appendChild(rightPill);

    banner.appendChild(inner);

    var anchor = document.querySelector('.shopify-section.main-product-section')
      || document.querySelector('#main');
    if (!anchor) return;
    if (anchor.id === 'main') {
      anchor.insertBefore(banner, anchor.firstChild);
    } else if (anchor.parentNode) {
      anchor.parentNode.insertBefore(banner, anchor);
    }
  }

  function makeSubBlock() {
    var sb = cfg.subBlock || {};
    var primary = sb.primary || 'PLUS: EXTRA 20% OFF IN YOUR CART!';
    var secondary = sb.secondary || 'Automatically applied at checkout';
    var badgeTop = sb.badgeTop || '20%';
    var badgeBottom = sb.badgeBottom || 'OFF';
    var wrap = document.createElement('div');
    wrap.className = 'solvey-sale-sub-block';
    wrap.innerHTML =
      '<span class="solvey-sale-sub-block__sparkles" aria-hidden="true">✦ ✧</span>' +
      '<div class="solvey-sale-sub-block__text">' +
        '<div class="solvey-sale-sub-block__primary">' + primary + '</div>' +
        '<div class="solvey-sale-sub-block__secondary">' + secondary + '</div>' +
      '</div>' +
      '<span class="solvey-sale-sub-block__badge">' + badgeTop + '<br>' + badgeBottom + '</span>';
    return wrap;
  }

  function injectSubscriptionSaleBlock() {
    if (!cfg.isPDP) return;
    document.querySelectorAll('.subscription-card:not(.solvey-sale-sub-blocked)').forEach(function (card) {
      card.classList.add('solvey-sale-sub-blocked');
      // Append as direct child of subscription-card (LI) zodat sub-block de volle
      // card-breedte pakt (en niet wordt ingeperkt door de label-container die
      // smaller is dan de card).
      card.appendChild(makeSubBlock());
    });
  }

  function injectAtcSaleText() {
    if (!cfg.isPDP) return;
    var atcButtons = document.querySelectorAll(
      '.product-form__buttons button[name="add"]:not(.solvey-sale-atc-marked), ' +
      '.product-form__submit:not(.solvey-sale-atc-marked), ' +
      'button[name="add"]:not(.solvey-sale-atc-marked)'
    );
    atcButtons.forEach(function (btn) {
      btn.classList.add('solvey-sale-atc-marked');
      var span = document.createElement('span');
      span.className = 'solvey-sale-atc-msg';
      span.textContent = '20% OFF APPLIED IN YOUR CART!';
      if (btn.parentNode) btn.parentNode.insertBefore(span, btn.nextSibling);
    });
  }

  function makeBadge() {
    var badge = document.createElement('span');
    badge.className = 'solvey-sale-badge';
    setStyles(badge, cfg.badge.bg, cfg.badge.color);
    badge.textContent = cfg.badge.text || '';
    return badge;
  }

  function injectPriceBadges() {
    if (!cfg.badge || !cfg.badge.enabled) return;
    if (cfg.isPDP) {
      // 1. Standaard product-prijs (.product__price) — UITGESCHAKELD: badge in
      //    main price overlapt met rating naast de prijs op mobile (vooral NL).
      //    Badge zit al in subscription cards + sticky CTA + banner, dus
      //    redundant in main price. Verwijder bestaande als die er al staat.
      document.querySelectorAll(
        '.shopify-section.main-product-section .product__price.solvey-sale-badged .solvey-sale-badge'
      ).forEach(function (b) { b.remove(); });
      document.querySelectorAll(
        '.shopify-section.main-product-section .product__price.solvey-sale-badged'
      ).forEach(function (p) { p.classList.remove('solvey-sale-badged'); });
      // 2. Firmhouse subscription card price rows (.price-info per .card-row),
      //    zodat elke abonnement-optie ook de badge naast de prijs heeft.
      document.querySelectorAll(
        '.selling_plan_app_plans_list .price-info:not(.solvey-sale-badged), ' +
        '.subscription-card .price-info:not(.solvey-sale-badged)'
      ).forEach(function (p) {
        p.classList.add('solvey-sale-badged');
        p.appendChild(makeBadge());
      });
    }
    // 3. Foxify product-tabs collection cards (op /collections/all-products
    //    en homepage shop-tabs) — badge naast de prijs in elke card.
    document.querySelectorAll(
      '[class*="ai-product-tabs-price-wrapper-"]:not(.solvey-sale-badged)'
    ).forEach(function (p) {
      p.classList.add('solvey-sale-badged');
      p.appendChild(makeBadge());
    });
    // 4. Foxify bundle-cards (bfeb533) — badge naast bundle-prijs.
    document.querySelectorAll(
      '[class*="ai-bundle-pricing-"]:not(.solvey-sale-badged)'
    ).forEach(function (p) {
      p.classList.add('solvey-sale-badged');
      p.appendChild(makeBadge());
    });
    // 5. Custom sticky ATC bar — "-20%" pill direct na de prijs (vóór de button).
    //    Pill krijgt de BAR-bg-kleur (lime green) ipv de badge-kleur, zodat
    //    'ie als visuele accent uitkomt op de witte sticky bar.
    document.querySelectorAll(
      '#custom-sticky-atc .custom-sticky-atc__price:not(.solvey-sale-badged)'
    ).forEach(function (priceEl) {
      priceEl.classList.add('solvey-sale-badged');
      var pill = document.createElement('span');
      pill.className = 'solvey-sale-badge solvey-sale-badge--sticky-atc';
      setStyles(pill, cfg.bar && cfg.bar.bg, cfg.bar && cfg.bar.color);
      pill.textContent = '-20%';
      priceEl.appendChild(pill);
    });
  }

  function injectAllProductsHero() {
    // Match /collections/all-products met optionele 2-letter locale prefix
    // (/nl/, /en/, /de/, /fr/, /es/, /it/, /da/) zodat de injectie ook draait
    // op door Weglot/Shopify Markets gerouteerde URLs.
    if (!/^(?:\/[a-z]{2})?\/collections\/all-products(?:[\/?#]|$)/.test(location.pathname)) return;
    var h1 = document.querySelector('[class*="ai-collection-hero__title-"][class*="pyghm7"]');
    if (!h1) return;
    if (!document.querySelector('.solvey-sale-allproducts-hero')) {
      var container = h1.closest('[class*="ai-collection-hero__container-"]') || h1.parentElement;
      if (!container) return;

      // Wrap container in a relative positioned wrapper for stamp+arrow positioning
      container.classList.add('solvey-sale-allproducts-hero');

      // 1. Pill-badge boven h1
      var pill = document.createElement('div');
      pill.className = 'solvey-sale-allproducts-pill';
      pill.innerHTML = '<span class="solvey-sale-allproducts-pill__sparkle" aria-hidden="true">✦</span> 20% EXTRA KORTING IN JE WINKELWAGEN';
      container.insertBefore(pill, h1);

      // 2. Floral stamp + arrow rechts (alleen visible op desktop via CSS)
      var stampWrap = document.createElement('div');
      stampWrap.className = 'solvey-sale-allproducts-stamp-wrap';
      stampWrap.setAttribute('aria-hidden', 'true');
      // (arrow verwijderd 2026-05-21 — stamp staat los, geen verwijspijl meer)
      stampWrap.innerHTML = '';
      var stampHost = document.createElement('div');
      stampHost.className = 'solvey-sale-allproducts-stamp-host';
      stampHost.appendChild(makeFloralStamp());
      stampWrap.appendChild(stampHost);
      container.appendChild(stampWrap);
    }

    // 3. Em rond laatste woord van h1 — werkt voor EN base ("solution") én
    //    voor Weglot/Markets-vertaalde varianten (NL "balans" enz.). Weglot
    //    strip de inline <em> bij vertaling, dus we plaatsen 'm opnieuw via
    //    een MutationObserver op het h1-element zelf.
    ensureAllProductsHeroEm(h1);
    if (!h1.__solveySaleEmObs) {
      var emObs = new MutationObserver(function () { ensureAllProductsHeroEm(h1); });
      emObs.observe(h1, { childList: true, characterData: true, subtree: true });
      h1.__solveySaleEmObs = emObs;
    }
  }

  function ensureAllProductsHeroEm(h1) {
    if (!h1 || h1.querySelector('em')) return;
    var text = (h1.textContent || '').trim();
    if (!text) return;
    var m = text.match(/^([\s\S]*?)(\S+)\s*$/);
    if (!m) return;
    h1.innerHTML = (m[1] ? m[1] : '') + '<em>' + m[2] + '</em>';
  }

  function makeFloralStamp() {
    var stamp = document.createElement('div');
    stamp.className = 'solvey-sale-floral-stamp';
    stamp.setAttribute('aria-hidden', 'true');
    stamp.innerHTML =
      '<div class="solvey-sale-floral-stamp__bg"></div>' +
      '<div class="solvey-sale-floral-stamp__text">' +
        '<span class="solvey-sale-floral-stamp__big">20%</span>' +
        '<span class="solvey-sale-floral-stamp__mid">EXTRA KORTING</span>' +
        '<span class="solvey-sale-floral-stamp__small">IN JE WINKELWAGEN</span>' +
      '</div>' +
      '<span class="solvey-sale-floral-stamp__sparkle solvey-sale-floral-stamp__sparkle--1">✦</span>' +
      '<span class="solvey-sale-floral-stamp__sparkle solvey-sale-floral-stamp__sparkle--2">✧</span>';
    return stamp;
  }

  function injectHomepageHeroStamp() {
    var isHome = location.pathname === '/' || /^\/nl(\/)?$|^\/en(\/)?$|^\/de(\/)?$|^\/fr(\/)?$|^\/da(\/)?$/.test(location.pathname);
    if (!isHome) return;
    if (document.querySelector('.solvey-sale-home-stamp-wrap')) return;
    var heroBg = document.querySelector('[class*="hero-bg-"]') || document.querySelector('[class*="hero-template"]');
    if (!heroBg) return;
    var wrap = document.createElement('div');
    wrap.className = 'solvey-sale-home-stamp-wrap';
    wrap.appendChild(makeFloralStamp());
    heroBg.appendChild(wrap);
  }

  function syncBarHeight() {
    var bar = document.querySelector('.solvey-sale-bar');
    if (!bar) return;
    var h = bar.offsetHeight;
    if (h > 0) {
      document.documentElement.style.setProperty('--solvey-sale-bar-h', h + 'px');
    }
  }

  // Markeer product-titel elementen zodat Weglot ze NIET vertaalt.
  // Productnamen (bv. "Boric Acid", "Restore Probiotics") moeten in alle
  // talen identiek blijven — anders worden ze "Boorzuur" / "Herstellende
  // probiotica" wat verwarrend is t.o.v. de fysieke verpakking.
  function markProductTitlesNoTranslate() {
    var selectors = [
      '.shopify-section.main-product-section h1',
      '.custom-sticky-atc__title',
      '[class*="ai-product-tabs-title-"]',
      '.product-card__title',
      '[class*="product-card__title"]',
      '[class*="featured-product-title"]',
      '.quick-search__result-heading',
      '.cart-item__title a',
      '.cart-line-item__title',
      '[data-product-type="title"]'
    ];
    document.querySelectorAll(selectors.join(', ')).forEach(function (el) {
      if (el.classList.contains('wg-notranslate')) return;
      el.classList.add('wg-notranslate');
      el.setAttribute('data-wg-notranslate', '');
    });
  }

  function init() {
    injectSitewideBar();
    injectPdpBanner();
    injectPriceBadges();
    injectSubscriptionSaleBlock();
    injectAtcSaleText();
    injectAllProductsHero();
    injectHomepageHeroStamp();
    markProductTitlesNoTranslate();
    syncBarHeight();
    window.addEventListener('resize', syncBarHeight);
    if ('ResizeObserver' in window) {
      var bar = document.querySelector('.solvey-sale-bar');
      if (bar) new ResizeObserver(syncBarHeight).observe(bar);
    }
    // MutationObserver vangt late-DOM titles (cart drawer, quickview) op
    // én herhaalt de injects voor dynamische content.
    var mo = new MutationObserver(function () {
      markProductTitlesNoTranslate();
      if (cfg.badge && cfg.badge.enabled) {
        injectPriceBadges();
        injectSubscriptionSaleBlock();
        injectAtcSaleText();
      }
    });
    mo.observe(document.body, { subtree: true, childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
